import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  GenerateReportRequestBody,
  GenerateReportResponse,
  DataLookupResponse,
  GeneratedReportsRequestQuery,
  DeleteReportResponse,
  FieldSet,
  S3LinkResponse,
  GeneratedReportsResponseBody,
  IFormBase,
  GenerateAllReportsRequestBody
} from '@models/index';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private util = './assets/utility';

  constructor(
    private http: HttpClient
  ) { }

  public generateReport(body: GenerateReportRequestBody): Observable<GenerateReportResponse> {
    const { root, path } = environment.url.api;
    const url = root + path.report;
    return this.http.post<GenerateReportResponse>(url, body);
  }

  //Generate all reports utility
  public generateAllReports(body: GenerateAllReportsRequestBody): Observable<GenerateReportResponse> {
    const { root, path } = environment.url.api;
    const url = root + path.report;
    return this.http.post<GenerateReportResponse>(url, body);
  }



  public getS3FileLink(reportId: number, mockUser: string, s3Path: string) : Observable<S3LinkResponse> {
    const { root, path } = environment.url.api;
    const url = root + path.report + `/${reportId}/download?username=${mockUser}&s3_location=${s3Path}`;

    return this.http.get<S3LinkResponse>(url);
  }

  public getInputFieldOptions(field: IFormBase<string>, value: string, isDetailsModal?: boolean, formValues?: {[key: string]: unknown}): Observable<DataLookupResponse> {
    const { root, path } = environment.url.api;
    const {name, apiDependencyFields} = field;
    let url = root + path.datalookup + `?${name}=${encodeURIComponent(value)}`;
    if(apiDependencyFields){
      apiDependencyFields.forEach(field => {
          url += `&${field}=${encodeURIComponent(formValues?.[field] ? String(formValues[field]) : '0')}`;
      });
    }
    if(isDetailsModal){
      url = url+`&details=${isDetailsModal}`
    }
    return this.http.get<DataLookupResponse>(url);
  }

 public getInputFieldOptionsForReport(
  id: string,
  value: string,
  reloadParams?: Record<string, string>
): Observable<DataLookupResponse> {
  const { root, path } = environment.url.api;
  let url = `${root}${path.datalookup}?${id}=${encodeURIComponent(value).toLocaleLowerCase()}`;
  if (reloadParams) {
    const queryString = Object.entries(reloadParams)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&');
    url += `&${queryString}`;
  }

  return this.http.get<DataLookupResponse>(url);
}

  public getReportParams(reportType: string): Observable<FieldSet[]> {
    const url = `${this.util}/constants/${reportType.toLocaleLowerCase()}-report-param-fields.constant.json`;
    const reportParams$ = this.http.get<FieldSet[]>(url);

    return reportParams$;
  }

  public getGeneratedReports(params = 'all', query: GeneratedReportsRequestQuery): Observable<GeneratedReportsResponseBody> {
    const { root, path } = environment.url.api;
    const url = root + path.report + `/${params}?page=${query.page}&size=${query.size}&report_type=${query.report_type.toLocaleLowerCase()}`;

    return this.http.get<GeneratedReportsResponseBody>(url);
  }

  public getPendingReports() { // TODO: update code below after BE implemented
    const response = {
      mock$: of({ report_request_id: 'mock999' })
    };

    return response.mock$;
  }

  public deleteReport(reportId: number | string): Observable<DeleteReportResponse> {
    const { root, path } = environment.url.api;
    const url = root + path.report + `/${reportId}`;

    return this.http.delete<DeleteReportResponse>(url)
  }
}
